// extracted by mini-css-extract-plugin
module.exports = {"bannerBg":"_471229d"};